import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ServicesBento } from "@/components/home/ServicesBento";
import { Manifesto } from "@/components/home/Manifesto";
import { Facilities } from "@/components/home/Facilities";
import { About } from "@/components/home/About";
import { CtaBand } from "@/components/site/CtaBand";
import { ContactBlock } from "@/components/site/ContactBlock";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <ServicesBento />
      <About />
      <Facilities />
      <Manifesto />
      <CtaBand />
      <ContactBlock />
    </div>
  );
}
